import { render, staticRenderFns } from "./tab-iframe-component.vue?vue&type=template&id=d3b9be38"
import script from "./tab-iframe-component.vue?vue&type=script&lang=js"
export * from "./tab-iframe-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports